import React, { useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { MenuRounded, CloseRounded } from '@mui/icons-material';
import { useAuth } from '../contexts/AuthContext';
import UserMenu from './UserMenu';

const navLinkClass = ({ isActive }) =>
  isActive ? 'site-nav__link is-active' : 'site-nav__link';

function Header() {
  const {
    currentUser,
    navigateToPlatform,
    checkPermission,
    checkRole,
    mfaEnrolled,
    emailVerified,
    loading,
    sessionError,
    platformLaunch,
    clearPlatformLaunchError
  } = useAuth();
  const openingDecode = platformLaunch.status === 'opening';
  const hasDecodeAccess = checkRole('god') || checkPermission('insurance');
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  const scrollToProduct = () => {
    if (location.pathname === '/') {
      document.getElementById('product')?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleProductClick = () => {
    setMenuOpen(false);
    scrollToProduct();
  };

  return (
    <header className="site-header">
      <div className="site-container site-header__inner">
        <Link to="/" className="site-header__brand" aria-label="Decode home">
          <img src="/logo-512.png" alt="" className="site-header__mark" />
          <span className="site-header__wordmark">Decode</span>
        </Link>

        <div className="site-header__right">
          <nav className="site-nav" aria-label="Main">
            <ul className="site-nav__list">
              <li>
                <Link to="/#product" className="site-nav__link" onClick={handleProductClick}>
                  Product
                </Link>
              </li>
              <li>
                <NavLink to="/about" className={navLinkClass}>
                  About
                </NavLink>
              </li>
              <li>
                <NavLink to="/contact" className={navLinkClass}>
                  Contact
                </NavLink>
              </li>
            </ul>
          </nav>

          <div className="site-header__auth">
            {loading ? null : sessionError ? (
              <Link to="/login" className="btn btn--ghost btn--compact">Retry session verification</Link>
            ) : currentUser ? (
              <>
                {emailVerified && mfaEnrolled && hasDecodeAccess && (
                  <button
                    type="button"
                    className="btn btn--primary btn--compact"
                    onClick={() => navigateToPlatform('insurance')}
                    disabled={openingDecode}
                    aria-busy={openingDecode}
                  >
                    {openingDecode ? 'Opening Decode\u2026' : 'Decode'}
                  </button>
                )}
                <UserMenu />
              </>
            ) : (
              <Link to="/login" className="btn btn--ghost btn--compact">
                Login
              </Link>
            )}
          </div>

          <button
            type="button"
            className="site-header__menu"
            aria-label={menuOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((open) => !open)}
          >
            {menuOpen ? <CloseRounded fontSize="inherit" /> : <MenuRounded fontSize="inherit" />}
          </button>
        </div>
      </div>

      {platformLaunch.status === 'error' && (
        <div className="site-header__notice" role="alert">
          <div className="site-container site-header__notice-inner">
            <span>{platformLaunch.error}</span>
            <button
              type="button"
              className="site-header__notice-close"
              onClick={clearPlatformLaunchError}
              aria-label="Dismiss"
            >
              &times;
            </button>
          </div>
        </div>
      )}

      {menuOpen && (
        <div className="site-header__panel">
          <div className="site-container">
            <nav aria-label="Main, mobile">
              <ul className="site-header__panel-list">
                <li>
                  <Link to="/#product" className="site-header__panel-link" onClick={handleProductClick}>
                    Product
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="site-header__panel-link" onClick={() => setMenuOpen(false)}>
                    About
                  </Link>
                </li>
                <li>
                  <Link to="/contact" className="site-header__panel-link" onClick={() => setMenuOpen(false)}>
                    Contact
                  </Link>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      )}
    </header>
  );
}

export default Header;
